import { advancedSummaryHasValidAgreedPrice } from "../../helper/quoteServicePricingGate";
import { clientValidator } from "./clientValidator";
import { configurationValidator } from "./configurationValidator";
import { eventSchedulerValidator } from "./eventSchedulerValidator";
import { sectorValidator } from "./sectorWorkflowValidator";

export const buildValidations = (finalPayload: any) => ({
  client: clientValidator(finalPayload?.clientSelection),
  sector: sectorValidator(finalPayload?.sectorWorkflow),
  configuration: configurationValidator(finalPayload?.quoteOperationExpenses),
  scheduler: eventSchedulerValidator(finalPayload.eventScheduler),
  summary: advancedSummaryHasValidAgreedPrice(finalPayload),
});
